import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { serviceurl } from 'src/app/constant/constant';
import { unwrapPage, Paginated } from './pagination.util';

export interface ListingAsset {
  id: number;
  listing: number;
  format: 'pdf' | 'image' | 'foundry_vtt' | 'roll20' | 'other';
  file: string;
  version: number;
  is_current: boolean;
  created_at: string;
}

@Injectable({ providedIn: 'root' })
export class ListingAssetService {
  private apiUrl = serviceurl + 'api/v1/listing-assets';

  constructor(private http: HttpClient) {}

  upload(listingId: number, file: File, format: ListingAsset['format']): Observable<ListingAsset> {
    const formData = new FormData();
    formData.append('listing', String(listingId));
    formData.append('format', format);
    formData.append('file', file);
    return this.http.post<ListingAsset>(`${this.apiUrl}/`, formData);
  }

  listForListing(listingId: number): Observable<ListingAsset[]> {
    return this.http.get<Paginated<ListingAsset> | ListingAsset[]>(`${this.apiUrl}/`, { params: { listing: listingId } as any }).pipe(unwrapPage<ListingAsset>());
  }
}
